import { Box, Badge } from "@mui/material";
import { GridPagination } from "@mui/x-data-grid-pro";
import { tableGroups } from "../../hooks/useTableColumnsConfig";

const CustomPagination = (props) => {
  const legendItems = Object.keys(tableGroups).map(groupKey => {
    const group = tableGroups[groupKey];
    return {
      label: group.label,
      color: group.color,
    }
  });

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
          pl: 2,
        }}
      >
        {legendItems.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Badge
              sx={{
                "& .MuiBadge-badge": {
                  backgroundColor: item.color,
                },
              }}
              variant="dot"
            />
            {item.label}
          </Box>
        ))}
      </Box>

      <GridPagination {...props} />
    </Box>
  );
};

export default CustomPagination;
